import { apiClient } from './apiClient';

export interface Review {
  contractId: string;
  reviewerUserId: string;
  revieweeUserId: string;
  rating: number;
  comment: string;
  role: 'client_to_creator' | 'creator_to_client';
  dimensionRatings?: Record<string, number>;
  createdAt: number;
}

export const reviewService = {
  submitReview: async (contractId: string, rating: number, comment: string, dimensionRatings?: Record<string, number>) => {
    return apiClient.post<{ success: boolean; review: Review }>(
      `/api/v1/contracts/${contractId}/reviews`, { rating, comment, dimensionRatings }
    );
  },

  getContractReviews: async (contractId: string) => {
    return apiClient.get<{ reviews: Review[] }>(
      `/api/v1/contracts/${contractId}/reviews`
    );
  },

  getUserReviews: async (userId: string) => {
    return apiClient.get<{ reviews: Review[]; averageRating: number; reviewCount: number }>(
      `/api/v1/user/${userId}/reviews`
    );
  },
};
